import type { ReactNode } from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import {
  STATUS_SCREENS,
  type StatusScreen,
} from "./assistant-screens";

/** Same orb-to-copy gap as `ConversationStage` / `DisplayMessage`. */
const ORB_TO_COPY_PX = 48;

type Props = {
  screen: StatusScreen;
  orb: ReactNode;
  message: string;
};

/** Centred orb over a single heading. Caller supplies the outer stage. */
export function AssistantStatusStage({ screen, orb, message }: Props) {
  return (
    <Stack
      className="assistant__center"
      sx={{ gap: `${ORB_TO_COPY_PX}px`, alignItems: "center" }}
    >
      <Box>{orb}</Box>
      <Box className="assistant__copy">
        <Box
          component="h1"
          className={STATUS_SCREENS[screen].statusClassName}
        >
          {message}
        </Box>
      </Box>
    </Stack>
  );
}
